import api from "../../../services/instanceapi";
import {oneTagsURL, tagByCategoryURL} from "../../../services/api";
import {
    DELETE_TAG, DELETE_TAG_FAIL,
    FETCH_TAG,
    FETCH_TAG_FAIL,
    PATCH_TAG,
    PATCH_TAG_FAIL,
    POST_TAG,
    POST_TAG_FAIL
} from "../actionTypes";
import {checkErrorMessage} from "../../../utils/utils";
import {REQUEST_FAILED} from "../../message/actions/actionTypes";

export const postSubTag = (category_id, data) => async (dispatch) => {
    try {
        const tag = await api.post(tagByCategoryURL(category_id), data)
        dispatch({
            type: POST_TAG,
            payload: {
                status: tag.status,
                message: tag.statusText
            }
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: POST_TAG_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
            dispatch({
                type: REQUEST_FAILED,
            })
        }
        return Promise.reject(e)
    }
}

export const loadTag = (tag_id) => async (dispatch) => {
    try {
        const tag = await api.get(oneTagsURL(tag_id))
        dispatch({
            type: FETCH_TAG,
            payload: {
                id:tag.data.id,
                name : tag.data.name,
                color:tag.data.color,
                category:tag.data.category,
            }
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: FETCH_TAG_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
            dispatch({
                type: REQUEST_FAILED,
            })
        }
        return Promise.reject(e)
    }
}

export const patchTag = (tag_id, data) => async (dispatch) => {
    try {
        const tag = await api.patch(oneTagsURL(tag_id), data )

        dispatch({
            type: PATCH_TAG,
            payload: {
                status: tag.status,
                message: tag.statusText
            }
        })

        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: PATCH_TAG_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
            dispatch({
                type: REQUEST_FAILED,
            })
        }
        return Promise.reject(e)
    }
}

export const deleteTag = (tag_id) => async (dispatch) => {
    try {
        const tag = await api.delete(oneTagsURL(tag_id) )
        dispatch({
            type: DELETE_TAG,
            payload: {
                status: tag.status,
                message: tag.statusText
            }
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: DELETE_TAG_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
            dispatch({
                type: REQUEST_FAILED,
            })
        }
        return Promise.reject(e)
    }
}